import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import { Uploader } from 'components/Uploader';
import useApp from 'hooks/useApp';

import useEditPage from 'hooks/useEditPage';
const ServicesEditPage = (props) => {
		const app = useApp();
	// form validation schema
	const validationSchema = yup.object().shape({
		name: yup.string().required().label("Name"),
		description: yup.string().nullable().label("Description"),
		category: yup.string().required().label("Category"),
		baseprice: yup.number().required().label("Baseprice"),
		priceperkg: yup.number().nullable().label("Priceperkg"),
		minimumweight: yup.number().nullable().label("Minimumweight"),
		estimateddurationhours: yup.number().required().label("Estimateddurationhours"),
		isavailable: yup.string().nullable().label("Isavailable"),
		imageurl: yup.string().nullable().label("Imageurl"),
		createdat: yup.string().nullable().label("Createdat")
	});
	// form default values
	const formDefaultValues = {
		name: '', 
		description: '', 
		category: '', 
		baseprice: '', 
		priceperkg: '', 
		minimumweight: '', 
		estimateddurationhours: '', 
		isavailable: "((1))", 
		imageurl: '', 
		createdat: "(getdate())", 
	}
	//where page logics resides
	const pageController = useEditPage({ props, formDefaultValues, afterSubmit });
	//destructure and grab what we need
	const { formData, handleSubmit, submitForm, pageReady, loading, saving, apiRequestError, inputClassName } = pageController
	//Event raised on form submit success
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/services`);
		}
	}
	// loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	//display error page 
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	//page is ready when formdata loaded successfully
	if(pageReady){
		return (
<main id="ServicesEditPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="Edit Service"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema} 
                            onSubmit={(values, actions) => {
                            submitForm(values);
                            }
                            }
                            >
                            { (formik) => {
                            return (
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Name *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="name"  onChange={formik.handleChange}  value={formik.values.name}   label="Name" type="text" placeholder="Enter Name"        className={inputClassName(formik?.errors?.name)} />
                                                <ErrorMessage name="name" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Description 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="description"  onChange={formik.handleChange}  value={formik.values.description}   label="Description" type="text" placeholder="Enter Description"        className={inputClassName(formik?.errors?.description)} />
                                                <ErrorMessage name="description" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Category *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/category_option_list_2"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="category"     optionLabel="label" optionValue="value" value={formik.values.category} onChange={formik.handleChange} options={response} label="Category"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.category)}   />
                                                    <ErrorMessage name="category" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Baseprice *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="baseprice"  onChange={formik.handleChange}  value={formik.values.baseprice}   label="Baseprice" type="number" placeholder="Enter Baseprice"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.baseprice)} />
                                                <ErrorMessage name="baseprice" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Priceperkg 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="priceperkg"  onChange={formik.handleChange}  value={formik.values.priceperkg}   label="Priceperkg" type="number" placeholder="Enter Priceperkg"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.priceperkg)} />
                                                <ErrorMessage name="priceperkg" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Minimumweight 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="minimumweight"  onChange={formik.handleChange}  value={formik.values.minimumweight}   label="Minimumweight" type="number" placeholder="Enter Minimumweight"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.minimumweight)} />
                                                <ErrorMessage name="minimumweight" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Estimateddurationhours *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="estimateddurationhours"  onChange={formik.handleChange}  value={formik.values.estimateddurationhours}   label="Estimateddurationhours" type="number" placeholder="Enter Estimateddurationhours"  min={0}  step="any"    className={inputClassName(formik?.errors?.estimateddurationhours)} />
                                                <ErrorMessage name="estimateddurationhours" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Isavailable 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="isavailable"  onChange={formik.handleChange}  value={formik.values.isavailable}   label="Isavailable" type="text" placeholder="Enter Isavailable"        className={inputClassName(formik?.errors?.isavailable)} />
                                                <ErrorMessage name="isavailable" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Imageurl 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <div className={inputClassName(formik?.errors?.imageurl)}>
                                                    <Uploader name="imageurl" showUploadedFiles value={formik.values.imageurl} uploadPath="fileuploader/upload/imageurl" onChange={(paths) => formik.setFieldValue('imageurl', paths)} fileLimit={1} maxFileSize={3} accept=".jpg,.png,.gif,.jpeg" multiple={false} label="Choose files or drop files here" onUploadError={(errMsg) => app.flashMsg('Upload error', errMsg, 'error')} />
                                                </div>
                                                <ErrorMessage name="imageurl" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Createdat 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="createdat" value={formik.values.createdat} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.createdat)}        />
                                                <ErrorMessage name="createdat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)}  type="submit" label="Update" icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            );
                            }
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}
ServicesEditPage.defaultProps = {
	primaryKey: 'id',
	pageName: 'services',
	apiPath: 'services/edit',
	routeName: 'servicesedit',
	submitButtonLabel: "Update",
	formValidationError: "Form is invalid",
	formValidationMsg: "Please complete the form",
	msgTitle: "Update Record",
	msgAfterSave: "Record updated successfully",
	msgBeforeSave: "",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default ServicesEditPage;
